export const ACTIVATE_MEDIA_SEARCH_TRANSLATION_OPTIONS = "ACTIVATE_MEDIA_SEARCH_TRANSLATION_OPTIONS";
export const ADD_MEDIA_TIMESERIES = "ADD_MEDIA_TIMESERIES";
export const ADD_TRANSLATION_TO_TRANSCRIPTS = "ADD_TRANSLATION_TO_TRANSCRIPTS"; // FLAG_ATTEMPTING_TO_TRANSLATE_MISSING_TRANSCRIPTS
export const ADD_USER_CREATED_SEARCH = "ADD_USER_CREATED_SEARCH";
export const ATTEMPTING_LOG_IN = "ATTEMPTING_LOG_IN";
export const BACK_TO_LOGIN = "BACK_TO_LOGIN";
export const BEGIN_TOPIC_ISOLATION_PIE = "BEGIN_TOPIC_ISOLATION_PIE";
export const BEGIN_TOPIC_ISOLATION_LEGEND = "BEGIN_TOPIC_ISOLATION_LEGEND";
export const CANCEL_FTUX = "CANCEL_FTUX";
export const CHANGE_FEED_TYPE = "CHANGE_FEED_TYPE";
export const CHANGE_PASSWORD_ERROR = "CHANGE_PASSWORD_ERROR";
export const CHANGE_PASSWORD_SUCCESS = "CHANGE_PASSWORD_SUCCESS";
export const CLEAR_CROSSTABS_SEARCH_INPUT = "CLEAR_CROSSTABS_SEARCH_INPUT";
export const CLEAR_CROSSTABS_STATS = "CLEAR_CROSSTABS_STATS";
export const CLEAR_DATA_ON_SIGN_OUT = "CLEAR_DATA_ON_SIGN_OUT";
export const CLEAR_DELETE_DATA_EXPLORER_SEARCH_MODAL = "CLEAR_DELETE_DATA_EXPLORER_SEARCH_MODAL";
export const CLEAR_DELETE_WEB_SEARCH_MODAL = "CLEAR_DELETE_WEB_SEARCH_MODAL";
export const CLEAR_FALLBACK_WARNING = "CLEAR_FALLBACK_WARNING";
export const CLEAR_SOCIAL_INDICATOR = "CLEAR_SOCIAL_INDICATOR";
export const CLEAR_VIDEO_ENTITIES_SEARCH = "CLEAR_VIDEO_ENTITIES_SEARCH";
export const CLEAR_VIDEO_TAB_FILTERS = "CLEAR_VIDEO_TAB_FILTERS";
export const CLOSE_ADD_SEARCH_TO_GRAPH_MODAL = "CLOSE_ADD_SEARCH_TO_GRAPH_MODAL";
export const CLOSE_CHANGE_PASSWORD_MODAL = "CLOSE_CHANGE_PASSWORD_MODAL";
export const CLOSE_CONTENT_HEADER_TOOLTIP = "CLOSE_CONTENT_HEADER_TOOLTIP";
export const CLOSE_CREATE_SEARCH_MODAL = "CLOSE_CREATE_SEARCH_MODAL";
export const CLOSE_CREATE_SOCIAL_SEARCH_MODAL = "CLOSE_CREATE_SOCIAL_SEARCH_MODAL";
export const CLOSE_CROSSTABS_BASIC_TOOLTIP = "CLOSE_CROSSTABS_BASIC_TOOLTIP";
export const CLOSE_CROSSTABS_INFO_TOOLTIP = "CLOSE_CROSSTABS_INFO_TOOLTIP";
export const CLOSE_CUSTOM_SOCIAL_DATE_PICKER = "CLOSE_CUSTOM_SOCIAL_DATE_PICKER";
export const CLOSE_DATA_EXPLORER_CONTENT_MODAL = "CLOSE_DATA_EXPLORER_CONTENT_MODAL";
export const CLOSE_DATA_EXPLORER_PDF_MODAL = "CLOSE_DATA_EXPLORER_PDF_MODAL";
export const CLOSE_DATA_EXPLORER_DELETE_SEARCH_MODAL = "CLOSE_DATA_EXPLORER_DELETE_SEARCH_MODAL";
export const CLOSE_DELETE_WEB_SEARCH_MODAL = "CLOSE_DELETE_WEB_SEARCH_MODAL";
export const CLOSE_DELETE_SEARCH_MODAL = "CLOSE_DELETE_SEARCH_MODAL";
export const CLOSE_DMA_TOOLTIP = "CLOSE_DMA_TOOLTIP";
export const CLOSE_DELETE_SOCIAL_SEARCH_MODAL = "CLOSE_DELETE_SOCIAL_SEARCH_MODAL";
export const CLOSE_DATA_EXPLORER_BAR_CHART_MODAL = "CLOSE_DATA_EXPLORER_BAR_CHART_MODAL";
export const CLOSE_GENERIC_TOOLTIP = "CLOSE_GENERIC_TOOLTIP";
export const CLOSE_GENERIC_LIGHT_TOOLTIP = "CLOSE_GENERIC_LIGHT_TOOLTIP";
export const CLOSE_MAP_INFO_TOOLTIP = "CLOSE_MAP_INFO_TOOLTIP";
export const CLOSE_NARRATIVE_MODAL = "CLOSE_NARRATIVE_MODAL";
export const CLOSE_PREDICTIVE_HEADER_TOOLTIP = "CLOSE_PREDICTIVE_HEADER_TOOLTIP";
export const CLOSE_SAVED_WEB_SEARCHES_MODAL = "CLOSE_SAVED_WEB_SEARCHES_MODAL";
export const CLOSE_USER_DROPDOWN = "CLOSE_USER_DROPDOWN";
export const CLOSE_VIDEO_MODAL = "CLOSE_VIDEO_MODAL";
export const CLOSE_VIDEO_ENTITY_SELECT = "CLOSE_VIDEO_ENTITY_SELECT";
export const CLOSE_VIDEO_TIMELINE_TOOLTIP = "CLOSE_VIDEO_TIMELINE_TOOLTIP";
export const CLOSE_WEB_PAGES_MODAL = "CLOSE_WEB_PAGES_MODAL";
export const CLOSE_WEB_PAGES_SAVE_AS_MODAL = "CLOSE_WEB_PAGES_SAVE_AS_MODAL";
export const CONFIG_LAZY_REDUCERS = "CONFIG_LAZY_REDUCERS";
export const CONTENT_NAVIGATION = "CONTENT_NAVIGATION";
export const CREATE_ORIGINAL_PASSWORD_ERROR = "CREATE_ORIGINAL_PASSWORD_ERROR";
export const CREATE_ORIGINAL_PASSWORD_SUCCESS = "CREATE_ORIGINAL_PASSWORD_SUCCESS";
export const CREATE_SEARCH_SELECT_LANGUAGE = "CREATE_SEARCH_SELECT_LANGUAGE";
export const NAVIGATION_COMPLETE = "NAVIGATION_COMPLETE";
export const DEACTIVATE_SEARCH = "DEACTIVATE_SEARCH";
export const WEB_PAGES_NAVIGATION = "WEB_PAGES_NAVIGATION";
export const END_SHOW_ENTITY_TRANSITION = "END_SHOW_ENTITY_TRANSITION";
export const END_TOPIC_ISOLATION = "END_TOPIC_ISOLATION";
export const ENTITY_VIEW_NAVIGATION = "ENTITY_VIEW_NAVIGATION";
export const ERROR_LOADING_TWEETS = "ERROR_LOADING_TWEETS";
export const FETCHING_CROSSTABS_DATA = "FETCHING_CROSSTABS_DATA";
export const FETCHING_DATA_EXPLORER_PDF_DATA = "FETCHING_DATA_EXPLORER_PDF_DATA";
export const FETCHING_MEDIA_ARTICLES = "FETCHING_MEDIA_ARTICLES";
export const FETCHING_POST_COMMENTS = "FETCHING_POST_COMMENTS";
export const FETCHING_REPORTS = "FETCHING_REPORTS";
export const FETCHING_TWEETS = "FETCHING_TWEETS";
export const FILTER_CONTENT_BY_DATE = "FILTER_CONTENT_BY_DATE";
export const FILTER_SOCIAL_CONTENT_BY_DATE = "FILTER_SOCIAL_CONTENT_BY_DATE";
export const FORCE_LOG_OUT = "FORCE_LOG_OUT";
export const FORCE_PASSWORD_UPDATE = "FORCE_PASSWORD_UPDATE";
export const FORMAT_SOCIAL_CONTENT_FILTERED_BY_DATE = "FORMAT_SOCIAL_CONTENT_FILTERED_BY_DATE";
export const HOVER_CROSSTABS_MAP = "HOVER_CROSSTABS_MAP";
export const MEDIA_FORMAT_CONTENT_FILTERED_BY_DATE = "MEDIA_FORMAT_CONTENT_FILTERED_BY_DATE";
export const MEDIA_GRAPH_SPINNER_ON = "MEDIA_GRAPH_SPINNER_ON";
export const MEDIA_SET_AGGREGATION_LEVEL = "MEDIA_SET_AGGREGATION_LEVEL";
export const MEDIA_TAB_NAVIGATION = "MEDIA_TAB_NAVIGATION";
export const MEDIA_ZOOM_COMPLETE = "MEDIA_ZOOM_COMPLETE";
export const INIT_FTUX = "INIT_FTUX";
export const INITIALIZE_CUSTOM_SOCIAL_DATE_PICKER = "INITIALIZE_CUSTOM_SOCIAL_DATE_PICKER";
export const LOAD_SAVED_WEB_SEARCH = "LOAD_SAVED_WEB_SEARCH";
export const LOADING_MEDIA_ENTITIES = "LOADING_MEDIA_ENTITIES";
export const LOADING_MEDIA_LINE = "LOADING_MEDIA_LINE";
export const LOG_IN_ERROR = "LOG_IN_ERROR";
export const LOG_IN_SUCCESS = "LOG_IN_SUCCESS";
export const MEDIA_FILTER_CLICK = "MEDIA_FILTER_CLICK";
export const MEDIA_FILTERS_CLEAR = "MEDIA_FILTERS_CLEAR";
export const MEDIA_FILTERS_APPLY = "MEDIA_FILTERS_APPLY";
export const MEDIA_SHOW_MORE_FILTERS = "MEDIA_SHOW_MORE_FILTERS";
export const NARRATIVES_TAB_FOCUS_MODE = "NARRATIVES_TAB_FOCUS_MODE";
export const NO_POST_COMMENTS = "NO_POST_COMMENTS";
export const NOT_LOGGED_IN = "NOT_LOGGED_IN";
export const OPEN_ADD_SEARCH_TO_GRAPH_MODAL = "OPEN_ADD_SEARCH_TO_GRAPH_MODAL";
export const OPEN_CHANGE_PASSWORD_MODAL = "OPEN_CHANGE_PASSWORD_MODAL";
export const OPEN_CONTENT_HEADER_TOOLTIP = "OPEN_CONTENT_HEADER_TOOLTIP";
export const OPEN_CREATE_SEARCH_MODAL = "OPEN_CREATE_SEARCH_MODAL";
export const OPEN_CREATE_SOCIAL_SEARCH_MODAL = "OPEN_CREATE_SOCIAL_SEARCH_MODAL";
export const OPEN_DATA_EXPLORER_CONTENT_MODAL = "OPEN_DATA_EXPLORER_CONTENT_MODAL";
export const OPEN_DATA_EXPLORER_PDF_MODAL = "OPEN_DATA_EXPLORER_PDF_MODAL";
export const OPEN_DELETE_WEB_SEARCH_MODAL = "OPEN_DELETE_WEB_SEARCH_MODAL";
export const OPEN_DELETE_DATA_EXPLORER_SEARCH_MODAL = "OPEN_DELETE_DATA_EXPLORER_SEARCH_MODAL";
export const OPEN_DELETE_SEARCH_MODAL = "OPEN_DELETE_SEARCH_MODAL";
export const OPEN_DELETE_SOCIAL_SEARCH_MODAL = "OPEN_DELETE_SOCIAL_SEARCH_MODAL";
export const OPEN_DMA_TOOLTIP = "OPEN_DMA_TOOLTIP";
export const OPEN_CROSSTABS_BASIC_TOOLTIP = "OPEN_CROSSTABS_BASIC_TOOLTIP";
export const OPEN_CROSSTABS_INFO_TOOLTIP = "OPEN_CROSSTABS_INFO_TOOLTIP";
export const OPEN_DATA_EXPLORER_BAR_CHART_MODAL = "OPEN_DATA_EXPLORER_BAR_CHART_MODAL";
export const OPEN_FORGOT_PASSWORD_VIEW = "OPEN_FORGOT_PASSWORD_VIEW";
export const OPEN_GENERIC_TOOLTIP = "OPEN_GENERIC_TOOLTIP";
export const OPEN_GENERIC_LIGHT_TOOLTIP = "OPEN_GENERIC_LIGHT_TOOLTIP";
export const OPEN_MAP_INFO_TOOLTIP = "OPEN_MAP_INFO_TOOLTIP";
export const OPEN_NARRATIVE_MODAL = "OPEN_NARRATIVE_MODAL";
export const OPEN_PREDICTIVE_HEADER_TOOLTIP = "OPEN_PREDICTIVE_HEADER_TOOLTIP";
export const OPEN_SAVE_FILTER_MODAL = "OPEN_SAVE_FILTER_MODAL";
export const OPEN_SAVED_WEB_SEARCHES_MODAL = "OPEN_SAVED_WESB_SEARCHES_MODAL";
export const OPEN_TAG_TOOLTIP = "OPEN_TAG_TOOLTIP";
export const OPEN_VIDEO_MODAL = "OPEN_VIDEO_MODAL";
export const OPEN_VIDEO_TIMELINE_TOOLTIP = "OPEN_VIDEO_TIMELINE_TOOLTIP";
export const OPEN_WEB_PAGES_MODAL = "OPEN_WEB_PAGES_MODAL";
export const OPEN_WEB_PAGES_SAVE_AS_MODAL = "OPEN_WEB_PAGES_SAVE_AS_MODAL";
export const PREPARE_NAVIGATION = "PREPARE_NAVIGATION";
export const PROACTIVELY_DELETE_USER_CREATED_SEARCH = "PROACTIVELY_DELETE_USER_CREATED_SEARCH";
export const RECEIVE_ALT_NARRATIVES_FOR_CROSSTABS = "RECEIVE_ALT_NARRATIVES_FOR_CROSSTABS";
export const RECEIVE_CONTENT_ENTITIES = "RECEIVE_CONTENT_ENTITIES";
export const RECEIVE_CROSSTABS_MAP_STATS = "RECEIVE_CROSSTABS_MAP_STATS";
export const RECEIVE_CROSSTABS_STATS = "RECEIVE_CROSSTABS_STATS";
export const REQUEST_DATA_EXPLORER_ENTITIES = "REQUEST_DATA_EXPLORER_ENTITIES";
export const RECEIVE_DATA_EXPLORER_ENTITIES = "RECEIVE_DATA_EXPLORER_ENTITIES";
export const RECEIVE_DATA_EXPLORER_ENTITIES_ERROR = "RECEIVE_DATA_EXPLORER_ENTITIES_ERROR";
export const RECEIVE_DATA_EXPLORER_ENTITIES_RETRY = "RECEIVE_DATA_EXPLORER_ENTITIES_RETRY";
export const RECEIVE_DATA_EXPLORER_FILTERS = "RECEIVE_DATA_EXPLORER_FILTERS";
export const RECEIVE_DATA_EXPLORER_PDF_DATA = "RECEIVE_DATA_EXPLORER_PDF_DATA";
export const RECEIVE_DATA_EXPLORER_PDF_DATA_ERROR = "RECEIVE_DATA_EXPLORER_PDF_DATA_ERROR";
export const RECEIVE_DATA_EXPLORER_PDF_DATA_RETRY = "RECEIVE_DATA_EXPLORER_PDF_DATA_RETRY";
export const RECEIVE_DATA_EXPLORER_SINGLE_ARTICLE = "RECEIVE_DATA_EXPLORER_SINGLE_ARTICLE";
export const RECEIVE_MEDIA_ARTICLES = "RECEIVE_MEDIA_ARTICLES";
export const RECEIVE_MEDIA_ARTICLES_ERROR = "RECEIVE_MEDIA_ARTICLES_ERROR";
export const RECEIVE_MEDIA_ARTICLES_RETRY = "RECEIVE_MEDIA_ARTICLES_RETRY";
export const RECEIVE_MEDIA_FILTERS = "RECEIVE_MEDIA_FILTERS";
export const UPDATE_MEDIA_FILTERS = "UPDATE_MEDIA_FILTERS";
export const FETCHING_MEDIA_DYNAMIC_FILTERS = "FETCHING_MEDIA_DYNAMIC_FILTERS";
export const RECEIVE_MEDIA_DYNAMIC_FILTERS = "RECEIVE_MEDIA_DYNAMIC_FILTERS";
export const RECEIVE_MEDIA_DYNAMIC_FILTERS_ERROR = "RECEIVE_MEDIA_DYNAMIC_FILTERS_ERROR";
export const SET_MEDIA_ACTIVE_SEARCH = "SET_MEDIA_ACTIVE_SEARCH";
export const SET_MEDIA_ARTICLES_CURSOR_POS = "SET_MEDIA_ARTICLES_CURSOR_POS";
export const SET_MEDIA_EXPANDED_QUERY = "SET_MEDIA_EXPANDED_QUERY";
export const SET_MEDIA_EXPANDED_QUERY_LOADING = "SET_MEDIA_EXPANDED_QUERY_LOADING";
export const SET_MEDIA_FILTER_FILTER_STRING = "SET_MEDIA_FILTER_FILTER_STRING";
export const SET_MEDIA_FILTER_LIST_OPEN = "SET_MEDIA_FILTER_LIST_OPEN";
export const SET_MEDIA_PENDING_FILTER_FILTER_STRING = "SET_MEDIA_PENDING_FILTER_FILTER_STRING";
export const SET_MEDIA_SAVED_FILTERS_OPEN = "SET_MEDIA_SAVED_FILTERS_OPEN";
export const SET_SHOW_MEDIA_EXPANDED_QUERY = "SET_SHOW_MEDIA_EXPANDED_QUERY";
export const RESET_MEDIA_ACTIVE_SEARCH = "RESET_MEDIA_ACTIVE_SEARCH";
export const RESET_MEDIA_ARTICLES_CURSOR_POS = "RESET_MEDIA_ARTICLES_CURSOR_POS";
export const RECEIVE_MEDIA_ENTITIES = "RECEIVE_MEDIA_ENTITIES";
export const RECEIVE_MEDIA_ENTITIES_ERROR = "RECEIVE_MEDIA_ENTITIES_ERROR";
export const RECEIVE_MEDIA_ENTITIES_RETRY = "RECEIVE_MEDIA_ENTITIES_RETRY";
export const RECEIVE_MEDIA_TIMESERIES = "RECEIVE_MEDIA_TIMESERIES";
export const RECEIVE_MEDIA_TIMESERIES_ERROR = "RECEIVE_MEDIA_TIMESERIES_ERROR";
export const RECEIVE_MEDIA_TIMESERIES_RETRY = "RECEIVE_MEDIA_TIMESERIES_RETRY";
export const RECEIVE_NARRATIVE_MODAL_BARGRAPH = "RECEIVE_NARRATIVE_MODAL_BARGRAPH";
export const RECEIVE_PHRASES = "RECEIVE_PHRASES";
export const RECEIVE_POST_COMMENTS = "RECEIVE_POST_COMMENTS";
export const RECEIVE_NARRATIVE_MODAL_TIMESERIES = "RECEIVE_NARRATIVE_MODAL_TIMESERIES";
export const RECEIVE_PHRASES_LEFT = "RECEIVE_PHRASES_LEFT";
export const RECEIVE_PHRASES_RIGHT = "RECEIVE_PHRASES_RIGHT";
export const RECEIVE_REPORTS = "RECEIVE_REPORTS";
export const RECEIVE_SEARCH_LIST = "RECEIVE_SEARCH_LIST";
export const RECEIVE_TOPIC_STATS = "RECEIVE_TOPIC_STATS";
export const RECEIVE_TWEETS = "RECEIVE_TWEETS";
export const RECEIVE_USER_SEARCHES = "RECEIVE_USER_SEARCHES";
export const RECEIVE_USER_SUBSCRIPTIONS = "RECEIVE_USER_SUBSCRIPTIONS";
export const RECEIVE_VIDEO_DATA = "RECEIVE_VIDEO_DATA";
export const RECEIVE_VIDEO_ENTITIES = "RECEIVE_VIDEO_ENTITIES";
export const RECEIVE_VIDEO_FEED = "RECEIVE_VIDEO_FEED";
export const RECEIVE_VIDEO_FILTERS = "RECEIVE_VIDEO_FILTERS";
export const RECOVER_PASSWORD_ERROR = "RECOVER_PASSWORD_ERROR";
export const RECOVER_PASSWORD_SUCCESS = "RECOVER_PASSWORD_SUCCESS";
export const REMOVE_MEDIA_TIMESERIES = "REMOVE_MEDIA_TIMESERIES";
export const REMOVE_SEARCH_FROM_GRAPH = "REMOVE_SEARCH_FROM_GRAPH";
export const REMOVE_MEDIA_FILTERS_IMMEDIATE = "REMOVE_MEDIA_FILTERS_IMMEDIATE";
export const REPORT_TAB_NAVIGATION = "REPORT_TAB_NAVIGATION";
export const REQUEST_PHRASES = "REQUEST_PHRASES";
export const REQUEST_COMPARE_PHRASES_LEFT = "REQUEST_COMPARE_PHRASES_LEFT";
export const REQUEST_COMPARE_PHRASES_RIGHT = "REQUEST_COMPARE_PHRASES_RIGHT";
export const RESET_CROSSTABS_CHARTS = "RESET_CROSSTABS_CHARTS";
export const RESET_DATA = "RESET_DATA";
export const RESET_PASSWORD_ERROR = "RESET_PASSWORD_ERROR";
export const RESET_PASSWORD_SUCCESS = "RESET_PASSWORD_SUCCESS";
export const SAVE_FILTER_SET_SPINNER = "SAVE_FILTER_SET_SPINNER";
export const SAVE_USER_SEARCH_ERROR = "SAVE_USER_SEARCH_ERROR";
export const SAVE_USER_SEARCH_SPINNER = "SAVE_USER_SEARCH_SPINNER";
export const SAVE_USER_SUCCESS = "SAVE_USER_SUCCESS";
export const SELECT_CREATE_SOCIAL_ACCOUNT = "SELECT_CREATE_SOCIAL_ACCOUNT";
export const SELECT_CREATE_SOCIAL_LANGUAGE = "SELECT_CREATE_SOCIAL_LANGUAGE";
export const SELECT_CREATE_SOCIAL_LOCATION = "SELECT_CREATE_SOCIAL_LOCATION";
export const SELECT_CREATE_SOCIAL_PLATFORM = "SELECT_CREATE_SOCIAL_PLATFORM";
export const SELECT_CREATE_SOCIAL_PROVINCE = "SELECT_CREATE_SOCIAL_PROVINCE";
export const SELECT_CREATE_SOCIAL_IDEOLOGY = "SELECT_CREATE_SOCIAL_IDEOLOGY";
export const SELECT_CREATE_SOCIAL_COUNTRY = "SELECT_CREATE_SOCIAL_COUNTRY";
export const SELECT_CREATE_SOCIAL_INFLUENCER = "SELECT_CREATE_SOCIAL_INFLUENCER";
export const SELECT_CREATE_SOCIAL_TOPIC = "SELECT_CREATE_SOCIAL_TOPIC";
export const SELECT_CROSSTABS_DATE = "SELECT_CROSSTABS_DATE";
export const SELECT_CROSSTABS_TOPIC = "SELECT_CROSSTABS_TOPIC";
export const SELECT_MEDIA_ENTITY_TYPE = "SELECT_MEDIA_ENTITY_TYPE";
export const SELECT_LANGUAGE = "SELECT_LANGUAGE";
export const SELECT_COUNTRY = "SELECT_COUNTRY";
export const SELECT_NARRATIVE_FACET = "SELECT_NARRATIVE_FACET";
export const SELECT_NARRATIVE_MODAL_DATE = "SELECT_NARRATIVE_MODAL_DATE";
export const SELECT_SEARCH_TO_ADD_TO_GRAPH = "SELECT_SEARCH_TO_ADD_TO_GRAPH";
export const SELECT_SOCIAL_DATE = "SELECT_SOCIAL_DATE";
export const SELECT_SOCIAL_ACCOUNT = "SELECT_SOCIAL_ACCOUNT";
export const SELECT_SOCIAL_LANGUAGE = "SELECT_SOCIAL_LANGUAGE";
export const SELECT_SOCIAL_PLATFORM = "SELECT_SOCIAL_PLATFORM";
export const SELECT_SOCIAL_PROVINCE = "SELECT_SOCIAL_PROVINCE";
export const SELECT_SOCIAL_LOCATION = "SELECT_SOCIAL_LOCATION";
export const SELECT_SOCIAL_IDEOLOGY = "SELECT_SOCIAL_IDEOLOGY";
export const SELECT_SOCIAL_COUNTRY = "SELECT_SOCIAL_COUNTRY";
export const SELECT_SOCIAL_INFLUENCER = "SELECT_SOCIAL_INFLUENCER";
export const SELECT_SOCIAL_SEARCH = "SELECT_SOCIAL_SEARCH";
export const SELECT_SOCIAL_TOPIC = "SELECT_SOCIAL_TOPIC";
export const SET_SOCIAL_TIMESERIES_EXPANDED = "SET_SOCIAL_TIMESERIES_EXPANDED";
export const SET_SOCIAL_TIMESERIES_SHRUNK = "SET_SOCIAL_TIMESERIES_SHRUNK";
export const RESET_SOCIAL_MEDIA_TABLE_CURSOR_POS = "RESET_SOCIAL_MEDIA_TABLE_CURSOR_POS";
export const SET_SOCIAL_MEDIA_TABLE_CURSOR_POS = "SET_SOCIAL_MEDIA_TABLE_CURSOR_POS";
export const SORT_SOCIAL_MEDIA_TABLE = "SORT_SOCIAL_MEDIA_TABLE";
export const SET_AGGREGATION_LEVEL = "SET_AGGREGATION_LEVEL";
export const SET_AGGREGATION_LEVEL_LEFT = "SET_AGGREGATION_LEVEL_LEFT";
export const SET_AGGREGATION_LEVEL_RIGHT = "SET_AGGREGATION_LEVEL_RIGHT";
export const SET_ALLOW_LOCATION_FILTERS_DURING_HIGHLIGHT = "SET_ALLOW_LOCATION_FILTERS_DURING_HIGHLIGHT";
export const SET_API = "SET_API";
export const SET_BROWSER_TYPE = "SET_BROWSER_TYPE";
export const SET_CURRENT_ZOOM = "SET_CURRENT_ZOOM";
export const SET_DATA_EXPLORER_SEARCH = "SET_DATA_EXPLORER_SEARCH";
export const SET_DATA_EXPLORER_SEARCHES_AVAILABLE = "SET_DATA_EXPLORER_SEARCHES_AVAILABLE";
export const SET_CURRENT_DATA_EXPLORER_DATASET_ID = "SET_CURRENT_DATA_EXPLORER_DATASET_ID";
export const SET_PROJECT = "SET_PROJECT";
export const SET_PROJECT_THEME = "SET_PROJECT_THEME";
export const SET_MEDIA_FILTER_SIDEBAR_OPEN = "SET_MEDIA_FILTER_SIDEBAR_OPEN";
export const SET_MEDIA_INDICATOR = "SET_MEDIA_INDICATOR";
export const SET_MEDIA_SORT_DETAILS = "SET_MEDIA_SORT_DETAILS";
export const SET_MEDIA_TRANSLATE_TOGGLE = "SET_MEDIA_TRANSLATE_TOGGLE";
export const SET_MEDIA_ARTICLES_EXPANDED = "SET_MEDIA_ARTICLES_EXPANDED";
export const SET_MEDIA_ENTITIES_EXPANDED = "SET_MEDIA_ENTITIES_EXPANDED";
export const SET_MEDIA_SEARCH_TRANSLATION_ENABLED = "SET_MEDIA_SEARCH_TRANSLATION_ENABLED";
export const SET_MEDIA_SEARCH_TRANSLATION_LANGUAGES = "SET_MEDIA_SEARCH_TRANSLATION_LANGUAGES";
export const SET_MEDIA_TIMESERIES_EXPANDED = "SET_MEDIA_TIMESERIES_EXPANDED";
export const SET_MEDIA_TIMESERIES_SHRUNK = "SET_MEDIA_TIMESERIES_SHRUNK";
export const SET_TIMESERIES_EXPANDED = "SET_TIMESERIES_EXPANDED";
export const SET_TIMESERIES_EXPANDED_LEFT = "SET_TIMESERIES_EXPANDED_LEFT";
export const SET_TIMESERIES_EXPANDED_RIGHT = "SET_TIMESERIES_EXPANDED_RIGHT";
export const SET_TIMESERIES_SHRUNK = "SET_TIMESERIES_SHRUNK";
export const SET_TIMESERIES_SHRUNK_LEFT = "SET_TIMESERIES_SHRUNK_LEFT";
export const SET_TIMESERIES_SHRUNK_RIGHT = "SET_TIMESERIES_SHRUNK_RIGHT";
export const SET_RELEVANCY = "SET_RELEVANCY";
export const SET_RELEVANCY_LEFT = "SET_RELEVANCY_LEFT";
export const SET_RELEVANCY_RIGHT = "SET_RELEVANCY_RIGHT";
export const SET_REPORTS_TAB_SEARCH_INPUT = "SET_REPORTS_TAB_SEARCH_INPUT";
export const SET_REPORTS_TAB_SORT_DETAILS = "SET_REPORTS_TAB_SORT_DETAILS";
export const SET_SEARCH_SIDEBAR_OPEN = "SET_SEARCH_SIDEBAR_OPEN";
export const SET_SEARCH_NAME = "SET_SEARCH_NAME";
export const SET_SEARCH_INPUT = "SET_SEARCH_INPUT";
export const SET_TERMS_AND_CONDITIONS_ACCEPTED = "SET_TERMS_AND_CONDITIONS_ACCEPTED";
export const SET_TOPIC_ISOLATION_FLAG = "SET_TOPIC_ISOLATION_FLAG";
export const SET_VIDEO_ENTITY_TYPE = "SET_VIDEO_ENTITY_TYPE";
export const SET_VIDEO_MODAL_TAB = "SET_VIDEO_MODAL_TAB";
export const SET_VIDEO_TAB_FETCH_KEY = "SET_VIDEO_TAB_FETCH_KEY";
export const SET_WEB_PAGES_SEARCH = "SET_WEB_PAGES_SEARCH";
export const SET_WEB_SEARCHES_AVAILABLE = "SET_WEB_SEARCHES_AVAILABLE";
export const SETUP_TOPIC_STATS = "SETUP_TOPIC_STATS";
export const SHOW_SHARE_FAIL_MESSAGE = "SHOW_SHARE_FAIL_MESSAGE";
export const SIGNED_OUT = "SIGNED_OUT";
export const SOCIAL_MEDIA_TAB_NAVIGATION = "SOCIAL_MEDIA_TAB_NAVIGATION";
export const START_SHOW_ENTITY_TRANSITION = "START_SHOW_ENTITY_TRANSITION";
export const STORE_FILTERS_FOR_ROUTE_CHANGE = "STORE_FILTERS_FOR_ROUTE_CHANGE";
export const SUBMIT_CUSTOM_SOCIAL_DATE = "SUBMIT_CUSTOM_SOCIAL_DATE";
export const SYNC_LANGUAGES = "SYNC_LANGUAGES";
export const SYNC_COUNTRIES = "SYNC_COUNTRIES";
export const SYNC_RELEVANCY = "SYNC_RELEVANCY";
export const SYNC_RELEVANCY_LEFT = "SYNC_RELEVANCY_LEFT";
export const SYNC_RELEVANCY_RIGHT = "SYNC_RELEVANCY_RIGHT";
export const TOGGLE_DATA_EXPLORER_TRANSLATION = "TOGGLE_DATA_EXPLORER_TRANSLATION";
export const TOGGLE_DMA_AGGREGATION = "TOGGLE_DMA_AGGREGATION";
export const TOGGLE_DMA_AGGREGATION_LEFT = "TOGGLE_DMA_AGGREGATION_LEFT";
export const TOGGLE_DMA_AGGREGATION_RIGHT = "TOGGLE_DMA_AGGREGATION_RIGHT";
export const TOGGLE_CROSSTABS_PERSPECTIVE = "TOGGLE_CROSSTABS_PERSPECTIVE";
export const TOGGLE_TRANSLATE_ENTITIES = "TOGGLE_TRANSLATE_ENTITIES";
export const TOGGLE_TRANSLATE_ENTITIES_COMPARE = "TOGGLE_TRANSLATE_ENTITIES_COMPARE";
export const TOGGLE_VIDEO_ENTITY_FILTER = "TOGGLE_VIDEO_ENTITY_FILTER";
export const TOGGLE_VIDEO_ENTITIES_DRAWER = "TOGGLE_VIDEO_ENTITIES_DRAWER";
export const TOGGLE_VIDEO_ENTITY_SELECT = "TOGGLE_VIDEO_ENTITY_SELECT";
export const UNHOVER_CROSSTABS_MAP = "UNHOVER_CROSSTABS_MAP";
export const UPDATE_CHANGE_PASSWORD_NEW = "UPDATE_CHANGE_PASSWORD_NEW";
export const UPDATE_CHANGE_PASSWORD_OLD = "UPDATE_CHANGE_PASSWORD_OLD";
export const UPDATE_CREATE_QUERY = "UPDATE_CREATE_QUERY";
export const UPDATE_CREATE_SEARCH_LOCATION = "UPDATE_CREATE_SEARCH_LOCATION";
export const UPDATE_CREATE_SEARCH_NAME = "UPDATE_CREATE_SEARCH_NAME";
export const UPDATE_CREATE_SOCIAL_QUERY = "UPDATE_CREATE_SOCIAL_QUERY";
export const UPDATE_CREATE_SOCIAL_SEARCH_NAME = "UPDATE_CREATE_SOCIAL_SEARCH_NAME";
export const UPDATE_CROSSTABS_SEARCH_INPUT = "UPDATE_CROSSTABS_SEARCH_INPUT";
export const UPDATE_CUSTOM_SOCIAL_END_DATE = "UPDATE_CUSTOM_SOCIAL_END_DATE";
export const UPDATE_CUSTOM_SOCIAL_END_TIME = "UPDATE_CUSTOM_SOCIAL_END_TIME";
export const UPDATE_CUSTOM_SOCIAL_START_DATE = "UPDATE_CUSTOM_SOCIAL_START_DATE";
export const UPDATE_CUSTOM_SOCIAL_START_TIME = "UPDATE_CUSTOM_SOCIAL_START_TIME";
export const UPDATE_DATA_EXPLORER_QUERY = "UPDATE_DATA_EXPLORER_QUERY";
export const UPDATE_MEDIA_SEARCH_INPUT = "UPDATE_MEDIA_SEARCH_INPUT";
export const UPDATE_MEDIA_TIME_END = "UPDATE_MEDIA_TIME_END";
export const UPDATE_MEDIA_TIME_START = "UPDATE_MEDIA_TIME_START";
export const UPDATE_LOGIN_EMAIL = "UPDATE_LOGIN_EMAIL";
export const UPDATE_LOGIN_NEW_PASSWORD = "UPDATE_LOGIN_NEW_PASSWORD";
export const UPDATA_LOGIN_VERIFICATION_CODE = "UPDATA_LOGIN_VERIFICATION_CODE";
export const UPDATE_OUTLET_FILTERS = "UPDATE_OUTLET_FILTERS";
export const UPDATE_PASSWORD = "UPDATE_PASSWORD";
export const UPDATE_REPORTS_TAB_SEARCH_INPUT = "UPDATE_REPORTS_TAB_SEARCH_INPUT";
export const UPDATE_SOCIAL_DATA = "UPDATE_SOCIAL_DATA";
export const UPDATE_SOCIAL_SEARCH_INPUT = "UPDATE_SOCIAL_SEARCH_INPUT";
export const UPDATE_VIDEO_ENTITIES_SEARCH = "UPDATE_VIDEO_ENTITIES_SEARCH";
export const UPDATE_VIDEO_TAB_FILTER_UI = "UPDATE_VIDEO_TAB_FILTER_UI";
export const UPDATE_WEB_PAGES_QUERY = "UPDATE_WEB_PAGES_QUERY";
export const SET_CURRENT_WEB_PAGES_COLLECTION_ID = "SET_CURRENT_WEB_PAGES_COLLECTION_ID";
export const VIDEO_TAB_NAVIGATION = "VIDEO_TAB_NAVIGATION";
// FLAG_CONVERT_DATAEXPLORER_TO_GRAPH_QL
export const CLEAR_DATA_EXPLORER_FILTERS = "CLEAR_DATA_EXPLORER_FILTERS";
export const REMOVE_DATA_EXPLORER_FILTER = "REMOVE_DATA_EXPLORER_FILTER";
export const TOGGLE_INCLUSIVE_FILTER = "TOGGLE_INCLUSIVE_FILTER";
export const TOGGLE_EXCLUSIVE_FILTER = "TOGGLE_EXCLUSIVE_FILTER";
export const SET_DATA_EXPLORER_FILTERS = "SET_DATA_EXPLORER_FILTERS";
export const SET_DATA_EXPLORER_ENTITIES = "SET_DATA_EXPLORER_ENTITIES";
export const SET_DATA_EXPLORER_DASHBOARD_EXPANDED = "SET_DATA_EXPLORER_DASHBOARD_EXPANDED";
export const PROCESSING_INITIAL_TRENDS_REQUEST = "PROCESSING_INITIAL_TRENDS_REQUEST";
export const RECEIVE_ARTICLES = "RECEIVE_ARTICLES";
export const RECEIVE_ARTICLES_ERROR = "RECEIVE_ARTICLES_ERROR";
export const RECEIVE_ARTICLES_RETRY = "RECEIVE_ARTICLES_RETRY";
export const SET_ARTICLES_CURSOR_POS = "SET_ARTICLES_CURSOR_POS";
export const RESET_ARTICLES_CURSOR_POS = "RESET_ARTICLES_CURSOR_POS";
export const RECEIVE_ENTITIES = "RECEIVE_ENTITIES";
export const RECEIVE_ENTITIES_ERROR = "RECEIVE_ENTITIES_ERROR";
export const RECEIVE_ENTITIES_RETRY = "RECEIVE_ENTITIES_RETRY";
export const SET_MAP_HIDDEN_BY_FILTERS = "SET_MAP_HIDDEN_BY_FILTERS";
export const MAP_DATA_LOADING = "MAP_DATA_LOADING";
export const RECEIVE_MAP_DATA = "RECEIVE_MAP_DATA";
export const RECEIVE_MAP_DATA_ERROR = "RECEIVE_MAP_DATA_ERROR";
export const RECEIVE_MAP_DATA_RETRY = "RECEIVE_MAP_DATA_RETRY";
export const SET_CURRENT_MAP_ID = "SET_CURRENT_MAP_ID";
export const SET_FILTER_BY_MAP_COUNTRY = "SET_FILTER_BY_MAP_COUNTRY";
export const SET_MAP_EXPANDED = "SET_MAP_EXPANDED";
export const SET_MAP_EXPANDED_LEFT = "SET_MAP_EXPANDED_LEFT";
export const SET_MAP_EXPANDED_RIGHT = "SET_MAP_EXPANDED_RIGHT";


export const SET_DATA_EXPLORER_FILTER_SIDEBAR_OPEN = "SET_DATA_EXPLORER_FILTER_SIDEBAR_OPEN";
export const SET_DATA_EXPLORER_SEARCH_SIDEBAR_OPEN = "SET_DATA_EXPLORER_SEARCH_SIDEBAR_OPEN";
export const SET_DATA_EXPLORER_SAVED_FILTERS_OPEN = "SET_DATA_EXPLORER_SAVED_FILTERS_OPEN";
export const SET_DATA_EXPLORER_ENTITIES_EXPANDED = "SET_DATA_EXPLORER_ENTITIES_EXPANDED";
export const SET_DATA_EXPLORER_CONTENT_EXPANDED = "SET_DATA_EXPLORER_CONTENT_EXPANDED";
export const SET_DATA_EXPLORER_SEARCH_INPUT = "SET_DATA_EXPLORER_SEARCH_INPUT";
export const UPDATE_DATA_EXPLORER_TIME_START = "UPDATE_DATA_EXPLORER_TIME_START";
export const UPDATE_DATA_EXPLORER_TIME_END = "UPDATE_DATA_EXPLORER_TIME_END";
export const CLOSE_DATA_EXPLORER_CREATE_SEARCH_MODAL = "CLOSE_DATA_EXPLORER_CREATE_SEARCH_MODAL";
export const OPEN_DATA_EXPLORER_CREATE_SEARCH_MODAL = "OPEN_DATA_EXPLORER_CREATE_SEARCH_MODAL";
export const UPDATE_DATA_EXPLORER_CREATE_SEARCH_NAME = "UPDATE_DATA_EXPLORER_CREATE_SEARCH_NAME";
export const UPDATE_DATA_EXPLORER_CREATE_SEARCH_QUERY = "UPDATE_DATA_EXPLORER_CREATE_SEARCH_QUERY";
export const DATA_EXPLORER_SAVE_USER_SEARCH_SUCCESS = "DATA_EXPLORER_SAVE_USER_SEARCH_SUCCESS";
export const DATA_EXPLORER_SAVE_USER_SEARCH_SPINNER = "DATA_EXPLORER_SAVE_USER_SEARCH_SPINNER";
export const DATA_EXPLORER_SAVE_USER_SEARCH_ERROR = "DATA_EXPLORER_SAVE_USER_SEARCH_ERROR";
export const ADD_DATA_EXPLORER_USER_CREATED_SEARCH = "ADD_DATA_EXPLORER_USER_CREATED_SEARCH";
export const UPDATE_DATA_EXPLORER_SEARCH_INPUT = "UPDATE_DATA_EXPLORER_SEARCH_INPUT";
export const SET_DATA_EXPLORER_SAVED_SEARCHES = "SET_DATA_EXPLORER_SAVED_SEARCHES";
export const DELETE_DATA_EXPLORER_USER_CREATED_SEARCH = "DELETE_DATA_EXPLORER_USER_CREATED_SEARCH";
export const RESET_DATA_EXPLORER_ACTIVE_SEARCH = "RESET_DATA_EXPLORER_ACTIVE_SEARCH";
export const SET_DATA_EXPLORER_SEARCH_NAME = "SET_DATA_EXPLORER_SEARCH_NAME";
export const SET_DATA_EXPLORER_FILTER_LIST_OPEN = "SET_DATA_EXPLORER_FILTER_LIST_OPEN";
export const SET_DATA_EXPLORER_FILTER_FILTER_STRING = "SET_DATA_EXPLORER_FILTER_FILTER_STRING";
export const SET_DATA_EXPLORER_PENDING_FILTER_FILTER_STRING = "SET_DATA_EXPLORER_PENDING_FILTER_FILTER_STRING";
export const FETCHING_DATA_EXPLORER_DYNAMIC_FILTERS = "FETCHING_DATA_EXPLORER_DYNAMIC_FILTERS";
export const RECEIVE_DATA_EXPLORER_DYNAMIC_FILTERS = "RECEIVE_DATA_EXPLORER_DYNAMIC_FILTERS";
export const RECEIVE_DATA_EXPLORER_DYNAMIC_FILTERS_ERROR = "RECEIVE_DATA_EXPLORER_DYNAMIC_FILTERS_ERROR";
export const DATA_EXPLORER_FILTER_CLICK = "DATA_EXPLORER_FILTER_CLICK";
export const DATA_EXPLORER_SHOW_MORE_FILTERS = "DATA_EXPLORER_SHOW_MORE_FILTERS";
export const DATA_EXPLORER_FILTERS_CLEAR = "DATA_EXPLORER_FILTERS_CLEAR";
export const DATA_EXPLORER_FILTERS_APPLY = "DATA_EXPLORER_FILTERS_APPLY";
export const REMOVE_DATA_EXPLORER_FILTERS_IMMEDIATE = "REMOVE_DATA_EXPLORER_FILTERS_IMMEDIATE";
export const UPDATE_DATA_EXPLORER_FILTERS = "UPDATE_DATA_EXPLORER_FILTERS";
export const DATA_EXPLORER_ZOOM_COMPLETE = "DATA_EXPLORER_ZOOM_COMPLETE";
export const SET_SHOW_DATA_EXPLORER_EXPANDED_QUERY = "SET_SHOW_DATA_EXPLORER_EXPANDED_QUERY";
export const SET_DATA_EXPLORER_EXPANDED_QUERY = "SET_DATA_EXPLORER_EXPANDED_QUERY";
export const SET_DATA_EXPLORER_EXPANDED_QUERY_LOADING = "SET_DATA_EXPLORER_EXPANDED_QUERY_LOADING";
export const SELECT_SOCIAL_CONTAINS = "SELECT_SOCIAL_CONTAINS";
export const DATA_EXPLORER_SET_SEARCHES_INITIALIZED = "DATA_EXPLORER_SET_SEARCHES_INITIALIZED";
export const DATA_EXPLORER_SET_TABLE_SORT = "DATA_EXPLORER_SET_TABLE_SORT";
export const DATA_EXPLORER_SET_TABLE_CURSOR_POS = "DATA_EXPLORER_SET_TABLE_CURSOR_POS";
export const DATA_EXPLORER_RESET_TABLE_CURSOR_POS = "DATA_EXPLORER_RESET_TABLE_CURSOR_POS";
export const DATA_EXPLORER_ACTIVATE_SEARCH_TRANSLATION_OPTIONS = "DATA_EXPLORER_ACTIVATE_SEARCH_TRANSLATION_OPTIONS";
export const DATA_EXPLORER_SET_SEARCH_TRANSLATION_LANGUAGES = "DATA_EXPLORER_SET_SEARCH_TRANSLATION_LANGUAGES";
export const DATA_EXPLORER_SET_SEARCH_TRANSLATION_ENABLED = "DATA_EXPLORER_SET_SEARCH_TRANSLATION_ENABLED";